// Test id filtrów i sortowania RP: jeden kontrakt dla obu paneli. Filtry są używane w widokach: listing (drawer na desktopie, modal na mobile), strona inwestycji, modal oferty i panel oferty na mapie.

export const SEARCH_FILTERS_AND_SORT_TEST_ID = {
    // Nagłówek filtrów
    SECTION_HEADER: "filters-section-header",

    // Obszary filtrów
    FILTER_AREA: {
        PROPERTY_TYPE: "filters-property-type-area",
        BUDGET: "filters-budget-area",
        ROOMS: "filters-rooms-area",
        SURFACE: "filters-surface-area",
        FLAT_FLOORS: "filters-flat-floors-area",
        DELIVERY_DATE: "filters-delivery-date-area",
        HOUSE_TYPE: "filters-house-type-area",
        HOUSE_FLOORS: "filters-house-floors-area",
        HOUSE_EXTRAS: "filters-house-extras-area"
    },

    // Obszar opcji sortowania (lista radiów albo zakładek), bez triggera, nagłówka i stopki
    SORT_AREA: "sort-options-area",

    // Wspólna stopka „Wybierz/Wyczyść” filtrów i sortowania
    FOOTER_BUTTONS: "footer-buttons"
};
// Test id filtrów i sortowania RP: jeden kontrakt dla obu paneli. Filtry są używane w widokach: listing (drawer na desktopie, modal na mobile), strona inwestycji, modal oferty i panel oferty na mapie.

export const SEARCH_FILTERS_AND_SORT_TEST_ID = {
    // Nagłówek filtrów
    SECTION_HEADER: "filters-section-header",

    // Obszary filtrów
    FILTER_AREA: {
        PROPERTY_TYPE: "filters-property-type-area",
        BUDGET: "filters-budget-area",
        ROOMS: "filters-rooms-area",
        SURFACE: "filters-surface-area",
        FLAT_FLOORS: "filters-flat-floors-area",
        DELIVERY_DATE: "filters-delivery-date-area",
        HOUSE_TYPE: "filters-house-type-area",
        HOUSE_FLOORS: "filters-house-floors-area",
        HOUSE_EXTRAS: "filters-house-extras-area"
    },

    // Obszar opcji sortowania (lista radiów albo zakładek), bez triggera, nagłówka i stopki
    SORT_AREA: "sort-options-area",

    // Wspólna stopka „Wybierz/Wyczyść” filtrów i sortowania
    FOOTER_BUTTONS: "footer-buttons"
};
